import { useState } from "react";
export function useFilter() {
    const [filterValue, setFilterValue] = useState("");
    const filterFn = (e) => {
        setFilterValue(e.currentTarget.value);
    };
    return { filterValue, filterFn };
}
